//
// CardTitle
//

import classNames from 'classnames';
import PropTypes from 'prop-types';

const CardTitle = function CardTitle(props) {
  const {
    className,
    title = null,
    level = 0,
    disabled = false,
    id,
  } = props;

  return (
    <div
      id={id}
      className={classNames(
        {
          'text-xl font-semibold': (level === 0),
          'text-lg font-semibold': (level === 1),
          'text-base font-medium': (level === 2),
          'text-base font-light underline': (level === 3),
          'opacity-50': disabled,
        },
        className,
      )}
    >
      {title}
    </div>
  );
};

CardTitle.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  level: PropTypes.number,
  disabled: PropTypes.bool,
};

export default CardTitle;
